module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "分配学习导师"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "assignAdviserForm",
    staticClass: "form",
    attrs: {
      "model": _vm.adviserParam,
      "rules": _vm.adviserRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('Tag', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.id + ' - ' + item.nickname) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学习导师",
      "prop": "studyAdviserId"
    }
  }, [_c('AdminUserSelect', {
    attrs: {
      "adminGroupCode": "userStudyAdviser",
      "needDefaultStudyAdviser": "0",
      "transfer": ""
    },
    model: {
      value: (_vm.adviserParam.studyAdviserId),
      callback: function($$v) {
        _vm.$set(_vm.adviserParam, "studyAdviserId", $$v)
      },
      expression: "adviserParam.studyAdviserId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分配原因",
      "prop": "reason"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.adviserParam.reason),
      callback: function($$v) {
        _vm.$set(_vm.adviserParam, "reason", $$v)
      },
      expression: "adviserParam.reason"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新生分配")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "3"
    }
  }, [_vm._v("离职原因")]), _vm._v(" "), _c('Option', {
    key: "4",
    attrs: {
      "value": "4"
    }
  }, [_vm._v("投诉属实更换班主任")]), _vm._v(" "), _c('Option', {
    key: "5",
    attrs: {
      "value": "5"
    }
  }, [_vm._v("无效投诉更换班主任 ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAssignAdviser
    },
    on: {
      "click": _vm.assignAdviser
    }
  }, [_vm._v("分配")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00e8bd51","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/modal/AssignUserStudyModal.vue
// module id = 1604
// module chunks = 8